import { render, staticRenderFns } from "./SectionTextRight.vue?vue&type=template&id=49403902&scoped=true"
import script from "./SectionTextRight.vue?vue&type=script&lang=js"
export * from "./SectionTextRight.vue?vue&type=script&lang=js"
import style0 from "./SectionTextRight.vue?vue&type=style&index=0&id=49403902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49403902",
  null
  
)

export default component.exports